import { render, staticRenderFns } from "./ContentView.vue?vue&type=template&id=0a27b00f&scoped=true"
import script from "./ContentView.ts?vue&type=script&lang=ts&external"
export * from "./ContentView.ts?vue&type=script&lang=ts&external"
import style0 from "./ContentView.scss?vue&type=style&index=0&id=0a27b00f&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a27b00f",
  null
  
)

export default component.exports